import api from '../../utils/axios';

const appointmentsByClientID = async (clientId) => {
	const { data } = await api.get(
		`/client-expert-relationships/appointments?search[clientId]=${clientId}&populate=true`
	);

	return data;
};

const appointmentsByExpertID = async (expertId) => {
	const { data } = await api.get(
		`/client-expert-relationships/appointments?search[expertId]=${expertId}&populate=true`
	);

	return data;
};

const createAppointment = async (
	clientExpertRelationshipId,
	appointmentDate
) => {
	const { data } = await api.post(`/appointments`, {
		clientExpertRelationshipId,
		appointmentDate,
		createdAt: new Date().toISOString(),
		acceptedByClient: 0,
		acceptedByExpert: 1,
	});

	return data;
};

const updateAppointmentByID = async (appointmentId, fields) => {
	const { data } = await api.patch(`/appointments/${appointmentId}`, fields);

	return data;
};

const deleteAppointment = async (appointmentId) => {
	return api.delete(`/appointments/${appointmentId}`);
};

const appointmentService = {
	appointmentsByClientID,
	appointmentsByExpertID,
	createAppointment,
	updateAppointmentByID,
	deleteAppointment,
};

export default appointmentService;
